"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Class represents workflow's process
 */
var process_dto_1 = require("./process.dto");
var ProcessWithTrackInfoDto = /** @class */ (function (_super) {
    __extends(ProcessWithTrackInfoDto, _super);
    function ProcessWithTrackInfoDto(id, name, initialStateId, categorySystemName, modifiedBy, modifiedOn) {
        var _this = _super.call(this, id, name, initialStateId, categorySystemName) || this;
        _this._modifiedBy = modifiedBy;
        _this._modifiedOn = modifiedOn;
        return _this;
    }
    ProcessWithTrackInfoDto.prototype.getModifiedBy = function () {
        return this._modifiedBy;
    };
    ProcessWithTrackInfoDto.prototype.getModifiedOn = function () {
        return this._modifiedOn;
    };
    ProcessWithTrackInfoDto.prototype.toJsonObject = function () {
        var process = _super.prototype.toJsonObject.call(this);
        process['modifiedBy'] = this._modifiedBy;
        process['modifiedOn'] = this._modifiedOn;
        return process;
    };
    ProcessWithTrackInfoDto.prototype.toJson = function () {
        return JSON.stringify(this.toJsonObject());
    };
    return ProcessWithTrackInfoDto;
}(process_dto_1.ProcessDto));
exports.ProcessWithTrackInfoDto = ProcessWithTrackInfoDto;
//# sourceMappingURL=process-with-track-info.dto.js.map